import { http } from '../../config/axios'

export default function putRepresentanteClienteComissao(comissao: any): Promise<string> {
  return http
    .put('api/representante-cliente-comissao', comissao)
    .then((res) => {
      return res.data as string
    })
    .catch((error) => {
      console.error('Erro put representante cliente comissao', error)
      throw Error(error.response.data)
    })
}
